import React from "react";
import { useInsuranceWarning } from "./insuranceWarning";

// Arbitrary-value classes only: Bootstrap 4's utilities (.border, .px-3, .mt-3, .rounded-lg) are
// !important in this bundle and would win over Tailwind's of the same name.
const CHIP_CLASSES =
  "no-insurance-chip inline-flex items-center px-[8px] py-[1px] rounded-[10px] border-[1px] border-[#FCD34D] bg-[#FFFBEB] text-[#92400E] text-[11px] font-inter font-medium whitespace-nowrap";

// Amber chip on the dashboard card when the visit has no insurance on file (see
// ./insuranceWarning.js); it takes the place of the insurance name, so a card shows it once. The
// full advice is in the tooltip. Otherwise renders `children` (the insurance name as before).
export const NoInsuranceChip = ({ row, className = "", children = null }) => {
  const warning = useInsuranceWarning(row);
  if (!warning) return children;
  return (
    <span
      role="status"
      data-no-insurance="card"
      title={warning.title}
      aria-label={warning.notice}
      className={`${CHIP_CLASSES} ${className}`}
    >
      {warning.label}
    </span>
  );
};

// The same warning as a line in a dialog that checks the patient in (Visit Status, Orders).
// Never blocks the dialog: staff can still go on.
export const NoInsuranceNotice = ({ row, className = "" }) => {
  const warning = useInsuranceWarning(row);
  if (!warning) return null;
  return (
    <div
      role="status"
      data-no-insurance="dialog"
      title={warning.title}
      className={`no-insurance-notice flex items-start gap-[8px] rounded-[8px] border-[1px] border-[#FCD34D] bg-[#FFFBEB] px-[12px] py-[8px] text-left text-[12px] leading-[17px] text-[#92400E] font-inter ${className}`}
    >
      <span aria-hidden="true" className="font-semibold">!</span>
      <span>{warning.notice}</span>
    </div>
  );
};

export default NoInsuranceChip;
